const PERSIST_KEY = 'checkin_dashboard_prefs_v1'

const persistPrefs = (filters, bucket) => {
  try {
    localStorage.setItem(PERSIST_KEY, JSON.stringify({
      period: filters.period,
      tagIds: filters.tagIds,
      operatorId: filters.operatorId,
      bucket
    }))
  } catch (e) { /* localStorage cheio/desligado: ignora */ }
}

export default {
  SET_FILTERS (state, partial) {
    state.filters = { ...state.filters, ...partial }
    persistPrefs(state.filters, state.bucket)
  },

  SET_BUCKET (state, bucket) {
    state.bucket = bucket
    persistPrefs(state.filters, state.bucket)
  },

  HYDRATE_FROM_LOCALSTORAGE (state) {
    try {
      const raw = localStorage.getItem(PERSIST_KEY)
      if (!raw) return
      const saved = JSON.parse(raw)
      if (saved.period) state.filters.period = saved.period
      if (Array.isArray(saved.tagIds)) state.filters.tagIds = saved.tagIds
      if (saved.operatorId) state.filters.operatorId = saved.operatorId
      if (saved.bucket) state.bucket = saved.bucket
    } catch (e) { /* JSON corrompido: ignora */ }
  },

  SET_OVERVIEW (state, payload) { state.overview = payload },
  SET_TIMELINE (state, payload) { state.timeline = payload || [] },
  SET_INSIGHTS (state, payload) { state.insights = payload || [] },
  SET_BY_TAG (state, payload) { state.byTag = payload || [] },
  SET_BYTAG_WINDOW (state, minutes) { state.byTagWindowMinutes = minutes },
  SET_HEATMAP (state, payload) {
    state.heatmap = payload || { tags: [], matrix: {} }
  },
  SET_OPERATORS (state, payload) { state.operators = payload || [] },
  SET_ANOMALIES (state, payload) { state.anomalies = payload },
  SET_FUNNEL (state, payload) { state.funnel = payload },
  SET_FLOW (state, payload) {
    state.flow = payload || { nodes: [], links: [], total_transitions: 0, unique_tags: 0 }
  },
  SET_TOP_LOCATIONS (state, payload) { state.topLocations = payload || [] },

  // Live feed (Pusher) — prepend novo evento, capa em 30 itens.
  PREPEND_LIVE_EVENT (state, payload) {
    const next = [payload, ...state.liveFeed]
    state.liveFeed = next.slice(0, 30)
  },
  CLEAR_LIVE_FEED (state) { state.liveFeed = [] },
  SET_LIVE_CONNECTED (state, value) { state.liveFeedConnected = !!value },
  SET_LIVE_PAUSED (state, value) { state.liveFeedPaused = !!value },

  SET_TAG_DETAIL (state, payload) { state.tagDetail = payload },
  SET_TAG_DETAIL_LOADING (state, value) { state.tagDetailLoading = !!value },
  SET_TAG_DETAIL_BUCKET (state, bucket) { state.tagDetailBucket = bucket },
  CLOSE_TAG_DETAIL (state) {
    state.tagDetail = null
    state.tagDetailLoading = false
    state.tagDetailField = null
    state.tagDetailFieldSecondary = null
    state.tagDetailFieldData = null
    state.tagDetailFieldLoading = false
  },
  SET_TAG_DETAIL_FIELD (state, fieldRef) { state.tagDetailField = fieldRef },
  SET_TAG_DETAIL_FIELD_SECONDARY (state, fieldRef) { state.tagDetailFieldSecondary = fieldRef },
  SET_TAG_DETAIL_FIELD_DATA (state, payload) { state.tagDetailFieldData = payload },
  SET_TAG_DETAIL_FIELD_LOADING (state, value) { state.tagDetailFieldLoading = !!value },

  SET_OPERATOR_DETAIL (state, payload) { state.operatorDetail = payload },
  SET_OPERATOR_DETAIL_LOADING (state, value) { state.operatorDetailLoading = !!value },
  CLOSE_OPERATOR_DETAIL (state) {
    state.operatorDetail = null
    state.operatorDetailLoading = false
    state.operatorDetailField = null
    state.operatorDetailFieldSecondary = null
    state.operatorDetailFieldData = null
    state.operatorDetailFieldLoading = false
  },
  SET_OPERATOR_DETAIL_FIELD (state, fieldRef) { state.operatorDetailField = fieldRef },
  SET_OPERATOR_DETAIL_FIELD_SECONDARY (state, fieldRef) { state.operatorDetailFieldSecondary = fieldRef },
  SET_OPERATOR_DETAIL_FIELD_DATA (state, payload) { state.operatorDetailFieldData = payload },
  SET_OPERATOR_DETAIL_FIELD_LOADING (state, value) { state.operatorDetailFieldLoading = !!value },

  SET_FIELD_PRIMARY (state, fieldRef) {
    state.fieldAnalysis = { ...state.fieldAnalysis, primary: fieldRef }
  },
  SET_FIELD_SECONDARY (state, fieldRef) {
    state.fieldAnalysis = { ...state.fieldAnalysis, secondary: fieldRef }
  },
  SET_FIELD_DATA (state, payload) {
    state.fieldAnalysis = { ...state.fieldAnalysis, data: payload }
  },
  SET_FIELD_LOADING (state, value) {
    state.fieldAnalysis = { ...state.fieldAnalysis, isLoading: value }
  },
  SET_FILTER_OPTIONS (state, payload) {
    state.filterOptions = {
      tags: payload.tags || [],
      operators: payload.operators || [],
      fields: payload.fields || [],
      active_dates: payload.active_dates || [],
      event: payload.event || null
    }
  },

  SET_POLLING_HANDLE (state, handle) { state.pollingHandle = handle },
  SET_LOADING (state, value) { state.isLoading = value },
  SET_FIRST_LOAD_DONE (state) { state.isFirstLoad = false },
  SET_LAST_UPDATE (state, date) { state.lastUpdate = date },
  SET_ERROR (state, err) { state.error = err }
}
